<template>
  <div class="content">
    <Background>
      <Login v-if="display == 0" :signup="() => setComponent(1)" :forgot="() => setComponent(2)" />
      <Signup v-else-if="display == 1" :login="() => setComponent(0)" />
      <ForgotPassword v-else-if="display == 2" :back="() => setComponent(0)" />
    </Background>
  </div>
</template>
<script>
import { ref, onMounted } from "vue";
import { useRoute } from "vue-router";
import { Login, Signup, ForgotPassword, Background } from "@/revamp/components";

export default {
  name: "Welcome",
  components: {
    Login,
    Signup,
    ForgotPassword,
    Background,
  },
  setup() {
    const display = ref(0);
    const route = useRoute();

    async function setComponent(page) {
      display.value = page;
    }

    onMounted(() => {
      if (route.query?.show === "forgot") {
        display.value = 2;
      } else if (route.query?.reset === "success") {
        display.value = 0;
        // Optional: show a brief success message (e.g. via a toast) that password was reset
      }
    });

    return {
      setComponent,
      display,
    };
  },
};
</script>
<style scoped lang="scss">
@import "@/revamp/assets/scss/colors.scss";
@import "@/revamp/assets/scss/elements.scss";
@import "@/revamp/assets/scss/variables.scss";
</style>
